import { AdminFriendlySubscriptionPlan } from 'types';

export const subscriptionPlans = {
  [AdminFriendlySubscriptionPlan.Standard]: 'Standard',
  [AdminFriendlySubscriptionPlan.Paid]: 'Legacy',
  [AdminFriendlySubscriptionPlan.Complimentary]: 'Complimentary',
};
